import React, { useState, useEffect } from "react";
import axios from "axios";
import ErrorPage from "./ErrorPage";
import { getData } from "../../resources/utils";

const getIcon = (level, expanded) => {
  switch (level) {
    case "country":
      return expanded ? "🌍 Country" : "🌎 Country";
    case "state":
      return "🗺️ State";
    case "district":
      return "🏙️ District";
    case "tehsil":
      return "🏡 Tehsil";
    case "village":
      return "🏠 Village";
    case "khasra":
      return "📄 Khasra";
    default:
      return "📄";
  }
};

const TreeItem = ({ node }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="pl-3">
      <div
        className="flex items-center gap-2 cursor-pointer hover:bg-gray-200 p-1 rounded text-gray-800 transition text-[20px]"
        onClick={() =>
          node.children?.length > 0 && setExpanded(!expanded)
        }
      >
        {node.children?.length > 0 ? (
          <span>{expanded ? "▼" : "▶"}</span>
        ) : (
          <span className="opacity-0">▶</span>
        )}

        <span>{getIcon(node.level, expanded)}</span>
        <span>{node.location_name}</span>
      </div>

      {expanded && node.children?.length > 0 && (
        <div className="ml-4 border-l border-gray-300 pl-2">
          {node.children.map((child) => (
            <TreeItem key={child.id} node={child} />
          ))}
        </div>
      )}
    </div>
  );
};

const TreeView = ({ selectedUserId }) => {
  const [userAccessData, setUserAccessData] = useState([]);
  const [featureAccess, setFeatureAccess] = useState([]);
  const [showErrorScreen, setShowErrorScreen] = useState(false);

  const transformAccessToTree = (data) => {
    const getNextLevel = (level) => {
      switch (level) {
        case "country":
          return "state";
        case "state":
          return "district";
        case "district":
          return "tehsil";
        case "tehsil":
          return "village";
        case "village":
          return "khasra";
        default:
          return "unknown";
      }
    };

    const buildTree = (obj, level = "country") => {
      return Object.keys(obj || {}).map((key, index) => {
        const value = obj[key];

        let children = [];

        if (Array.isArray(value)) {
          children = value.flatMap((item) => {
            if (item.khasra !== undefined) {
              return [
                {
                  id: `khasra-${item.khasra}-${index}`,
                  location_name: `Khasra: ${item.khasra}`,
                  level: "khasra",
                  children: [],
                },
              ];
            }

            if (typeof item === "object") {
              return buildTree(item, getNextLevel(level));
            }

            return [];
          });
        }

        return {
          id: `${key}-${index}-${level}`,
          location_name: key,
          level,
          children,
        };
      });
    };

    return buildTree(data);
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const payload = {
          admin_id: Number(localStorage.getItem("user_id")) || 0,
          type: "all_access",
          user_id: selectedUserId,
        };

        const oldAuth = axios.defaults.headers.common["Authorization"];
        delete axios.defaults.headers.common["Authorization"];

        const res = await getData(
          "agribhumi",
          "userfeature_and_location",
          payload,
          null
        );

        if (oldAuth) {
          axios.defaults.headers.common["Authorization"] = oldAuth;
        }

        const rawAccess = res?.data?.data?.access?.[0];
const rawFeatureAccess =
  res?.data?.data?.feature?.[0]?.feature;

const featureAccessData = Array.isArray(rawFeatureAccess)
  ? rawFeatureAccess
  : rawFeatureAccess
  ? [rawFeatureAccess]
  : [];

        setFeatureAccess(featureAccessData);

        if (!rawAccess) {
          setShowErrorScreen(true);
        } else {
          const treeData = transformAccessToTree(rawAccess);
          setUserAccessData(treeData);
        }
      } catch (err) {
        console.log("error", err);
        setShowErrorScreen(true);
      }
    };

    if (selectedUserId) {
      fetchUserDetails();
    }
  }, [selectedUserId]);

  return (
    <div className="p-4">

      <div className="mb-5 bg-gray-100 p-4 rounded-lg border">
        <h2 className="text-[22px] font-semibold mb-3 text-gray-800">
          🔐 Feature Access
        </h2>

        <div className="flex flex-wrap gap-2">
          {featureAccess.length > 0 ? (
            featureAccess.map((feature, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-[15px] font-medium"
              >
                {feature.name || feature}
              </span>
            ))
          ) : (
            <p className="text-gray-500">No Feature Access</p>
          )}
        </div>
      </div>

      {/* Tree View */}
      <div className="ml-4 border-l border-gray-300 pl-2">
        {showErrorScreen ? (
          <ErrorPage />
        ) : userAccessData.length > 0 ? (
          userAccessData.map((node) => (
            <TreeItem key={node.id} node={node} />
          ))
        ) : (
          <p className="text-gray-500">No Data Found</p>
        )}
      </div>
    </div>
  );
};

export default TreeView;